import { Dayjs } from 'dayjs'
import { antdHelpers } from '@gismart/ui.library/core'

const { generatePicker, generateDayjsConfig } = antdHelpers

export const DatePicker = generatePicker<Dayjs>(generateDayjsConfig)
